<template lang="html">
  <div id="parentx">
    <vs-sidebar
        v-if='user'
        :static-position="staticPosition"
        default-index="0"
        :parent="parent"
        :hiddenBackground="doNotClose"
        color="danger"
        class="sidebarx"
        spacer
        v-model="isSidebarActive"
        :click-not-close="doNotClose"
    >
      <div class="header-sidebar text-center" slot="header">
          <h3>Hoşgeldiniz</h3>
          <h6>{{ isimtemp }} {{ soyadtemp }}<br/>
           
          </h6>
           <h6>{{ emailtemp }}</h6>
      </div>
        <!--<template v-for="(sidebarLink, index) in sidebarLinks" > ayır fordan cıkar
          <vs-sidebar-item 
            v-if="yetkiSuperAdmin(sidebarLink)"
            :icon="sidebarLink.icon" 
            :to="sidebarLink.url"
            :key="`sidebarLink-${index}`" 
            :index="index"
            @click="handleClicked(sidebarLink)"
          >
            <span class="hide-in-minisidebar">{{ sidebarLink.name }}</span>
          </vs-sidebar-item>
      </template>-->
       <template>
       <vs-sidebar-item
        
          icon="mdi-home"
          to="/home"
          index="0"
      >
        <span class="hide-in-minisidebar">Anasayfa</span>
      </vs-sidebar-item>


       <vs-sidebar-item
       v-if="yetkiSuperAdmin() || yetkiSksAdmin() "
          icon="mdi-send"
           to="/finishevent"
            index="11"
            
      >
        <span class="hide-in-minisidebar">Etkinlik Gözlem (admin)</span>
      </vs-sidebar-item>
<!-- <vs-sidebar-item
          icon="mdi-file"
           to="/NewEvent"
            index="1"
            v-if="yetkiSuperAdmin() || yetkiIdariAdmin() || yetkiAkademisyen() || yetkiSksAdmin()"
      >
        <span class="hide-in-minisidebar">Hızlı Etkinlik Kayıt</span>
      </vs-sidebar-item> -->

        <vs-sidebar-item
          icon="mdi-clipboard-text"
           to="/appeals/create"
            index="2"
             v-if="yetkiSuperAdmin() || yetkiAkademisyen() || yetkiSksAdmin() || yetkiIdariAdmin() "
      >
        <span class="hide-in-minisidebar">Etkinlik Kayıt</span>
      </vs-sidebar-item>
      
       <vs-sidebar-item
          icon="mdi-clipboard-account"
           to="/MyActivities"
            index="3"
             v-if="yetkiSuperAdmin() ||  yetkiAkademisyen() || yetkiSksAdmin()"
      >
        <span class="hide-in-minisidebar">Etkinliklerim</span>
      </vs-sidebar-item>

       <!--<vs-sidebar-item
          icon="mdi-clipboard-account"
           to="/yoksis"
            index="4"
             v-if="yetkiSuperAdmin() || yetkiIdariAdmin() || yetkiAkademisyen() || yetkiSksAdmin()"
      >
        <span class="hide-in-minisidebar">HBV Etkinlikleri</span>
      </vs-sidebar-item>
      <vs-sidebar-item
          icon="mdi-clipboard-account"
           to="/students"
            index="5"
            
      >
        <span class="hide-in-minisidebar">Öğrenci Toplulukları Etkinlikleri</span>
      </vs-sidebar-item>-->


      <vs-sidebar-item
          icon="mdi-playlist-plus"
           to="/TaskManager"
            index="6"
              v-if="yetkiSuperAdmin() || yetkiIdariAdmin() || yetkiAkademisyen() || yetkiSksAdmin()"
      >
        <span class="hide-in-minisidebar">Görev Atama</span>
      </vs-sidebar-item>

       
<!--
       <vs-sidebar-item
          icon="mdi-calendar"
           to="/LastEvents"
            index="7"
            v-if="yetkiSuperAdmin() || yetkiAkademisyen() || yetkiSksAdmin() || yetkiIdariAdmin()"
      >
        <span class="hide-in-minisidebar">Son Etkinlikler</span>
      </vs-sidebar-item>-->

       

       <vs-sidebar-item
          icon="mdi-information-outline"
          to="/informations"
           index="8"
      >
        <span class="hide-in-minisidebar">Beni Görevli Ekle</span>
      </vs-sidebar-item>

       <vs-sidebar-item
          icon="mdi-file-chart"
           to="/surveys"
            index="9"
      >
        <span class="hide-in-minisidebar">Anketler</span>
      </vs-sidebar-item>

        <vs-sidebar-item
          icon="mdi-file-plus"
           to="/ends"
            index="10"
             v-if="yetkiSuperAdmin() || yetkiIdariAdmin() || yetkiSksAdmin() "
      >
        <span class="hide-in-minisidebar">Memnuniyet Anketi Ekle</span>
      </vs-sidebar-item>


       

       <vs-sidebar-item
        v-if="yetkiSuperAdmin() || yetkiIdariAdmin()  || yetkiSksAdmin()"
          icon="mdi-folder-multiple"
           to="/FolderManagement"
            index="12"
            
      >
        <span class="hide-in-minisidebar">Etkinlik Dosya Yönetimi</span>
      </vs-sidebar-item>

       <vs-sidebar-item
          icon="mdi-message-alert"
           @click="acUrl()"
            index="13"
      >
        <span class="hide-in-minisidebar">Etkinlik Öneri/Şikayet</span>
      </vs-sidebar-item>

       <!--<vs-sidebar-item
        v-if="yetkiSuperAdmin() || yetkiIdariAdmin() "
          icon="mdi-home-export-outline"
         @click="metabaseAc()"
           index="8"
          
      >
        <span class="hide-in-minisidebar">Raporlama Ekranı</span>
      </vs-sidebar-item> -->
<!--
       <vs-sidebar-item
          icon=" mdi-earth"
          to="/SocialContribution"
           index="14"
           v-if="yetkiSuperAdmin() || yetkiIdariAdmin()  || yetkiSksAdmin() "
      >
        <span class="hide-in-minisidebar">Toplumsal Katkı Ekranı</span>
      </vs-sidebar-item>
      
       <vs-sidebar-item
       v-if="yetkiSuperAdmin() || yetkiSksAdmin()"
          icon="mdi-checkbox-marked-circle-outline"
           to="/institutions"
            index="15"
      >
        <span class="hide-in-minisidebar">'Diğer' Onaylama (admin)</span>
      </vs-sidebar-item>

       <vs-sidebar-item
      v-if="yetkiSuperAdmin() "
          icon="mdi-comment-text"
           to="/reqqs"
            index="16"
      >
        <span class="hide-in-minisidebar">Dilek/Şikayet Görüntüleme (admin)</span>
      </vs-sidebar-item> -->

       <vs-sidebar-item
       v-if="yetkiSuperAdmin()"
          icon="mdi-account-group"
          to="/users"
           index="17"
      >
        <span class="hide-in-minisidebar">Kullanıcı ve Yetki Düzenleme</span>
      </vs-sidebar-item>

       <vs-sidebar-item
       v-if="yetkiSuperAdmin()"
          icon="mdi-chart-areaspline"
          to="/analytics"
           index="18"
      >
        <span class="hide-in-minisidebar">Uygulama Log Kayıtları</span>
      </vs-sidebar-item>

      <vs-sidebar-item
          icon="mdi-logout"
          @click="logout()"
      >
        <span class="hide-in-minisidebar">Çıkış</span>
      </vs-sidebar-item>
       </template>
      <div class="footer-sidebar" slot="footer">
      
          <vs-button icon="mdi-web" icon-pack="mdi" color="danger" type="flat" href="https://hacibayram.edu.tr/">HBV</vs-button>
      </div>

    </vs-sidebar>
  </div>

</template>

<script>
import User from "@/libs/users/User";
import { isAuthenticated, getUserFromStorage } from '@/utils/Customs'

  export default {
    name: "SideBar",
    props: {
      parent: {
          type: String
      },
      sidebarLinks: {
        type: Array,
        required: true,
      },
      staticPosition: {
        type: Boolean,
        default: true,
      },
      index: {
        default: null,
        type: [String, Number]
      }
    },

    data:() => ({
      user: getUserFromStorage(),
      emailtemp:"",
      isimtemp:"",
      soyadtemp:"",
         obj: new User(),
      windowWidth: window.innerWidth,
      doNotClose: false,
    }),

    computed: {
      //This is for mobile trigger
       //user() {
       // return this.obj.user
      //},
      isSidebarActive: {
        get() {
          return this.$store.state.isSidebarActive
        },
        set(val) {
          this.$store.commit('IS_SIDEBAR_ACTIVE', val)
        }
      }
    },

    watch: {
        user(val) {
        if(val) {

        }
      }
    },

    methods: {
      handleWindowResize(event) {
        this.windowWidth = event.currentTarget.innerWidth;
        this.setSidebar();
      },
      acUrl(){
        window.open('https://destek.hacibayram.edu.tr/');
      },
      setSidebar() {
        if (this.windowWidth < 1170) {
          this.$store.commit('IS_SIDEBAR_ACTIVE', false);
          this.doNotClose= false
        } 
        else {
          this.$store.commit('IS_SIDEBAR_ACTIVE', true);
          this.doNotClose= true 
        }
      },
      handleClicked(sidebarLink) {
        if(! this.doNotClose) {
          this.$store.commit('IS_SIDEBAR_ACTIVE', this.doNotClose);
          this.doNotClose= false
        }
      },

      logout() {
       
        Event.fire('APP_LOGOUT', 'sidebar')
        
        location.reload();
        
      },
      
      yetkiSuperAdmin(){
              if(this.user){
                if(this.user.turId=="903" || this.user.adKullaniciAdi== 'admin' || this.user.adKullaniciAdi== 'meryem.aciksoz' || this.user.adKullaniciAdi== 'gokce.ozer' )
                  return true; 
              }
                       
      },
      
      yetkiIdariAdmin(){
              if(this.user){
                 if(this.user.turId== '904')
                return true;    
              }
                   
      },
      yetkiSksAdmin(){
              if(this.user){
                if(this.user.turId== '905')
                return true; 
              }
                       
      },
      yetkiUser(){
              if(this.user){
                if(this.user.turId== '200' || this.user.turId== '201' || this.user.turId== '202' || this.user.turId== '203' || this.user.turId== '204' || this.user.turId== '205' || this.user.turId== '206' || this.user.turId== '207') 
                return true; 
              }
                       
      },
       yetkiAkademisyen(){
                if(this.user){
               if(this.user.turId== '100' || this.user.turId== '101' || this.user.turId== '102' || this.user.turId== '103' || this.user.turId== '104')
                return true;     
              }
                  
      },
      
      
      metabaseAc(){
        var google = window.open('https://eys.hacibayram.edu.tr:3000/', "_blank"); 
      }
    },

    mounted() {
      this.$nextTick(() => {
        window.addEventListener('resize', this.handleWindowResize);
      });
      

      if(this.user){
        this.isimtemp=this.user.adi
        this.emailtemp=this.user.email
        this.soyadtemp=this.user.soyadi
        this.setSidebar();
      }
    },

    beforeDestroy() {
      window.removeEventListener('resize', this.handleWindowResize);
      this.setSidebar();
    }
  }
</script>